import { render, staticRenderFns } from "./CounterCard.vue?vue&type=template&id=199f4806&"
import script from "./CounterCard.vue?vue&type=script&lang=ts&"
export * from "./CounterCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports